// File d'attente espaçant les appels aux Cloud Functions `addXP` et `saveExerciseProgress`.
// Ces deux CF partagent le même compteur serveur (`users/{uid}/_rateLimits/xp`, 3 s entre deux appels,
// voir functions/index.js) : deux appels rapprochés — même venant de pages différentes — voient le 2e
// refusé en `resource-exhausted` (429) et l'XP est perdu. On ne touche PAS au rate-limit serveur
// (anti-farming) : le client attend simplement son tour, au lieu de perdre l'appel.

export const XP_MIN_GAP_MS = 3200; // 3000 ms serveur + marge de latence réseau

export function createSpacedQueue(
  minGapMs = XP_MIN_GAP_MS,
  now = () => Date.now(),
  sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms))
) {
  let tail = Promise.resolve();
  let lastEnd = 0; // fin du dernier appel : le serveur a écrit son compteur avant cet instant

  return function enqueue(task) {
    const run = tail.then(async () => {
      const wait = lastEnd + minGapMs - now();
      if (wait > 0) await sleep(wait);
      try {
        return await task();
      } finally {
        lastEnd = now();
      }
    });
    // Un échec ne doit pas bloquer les appels suivants de la file.
    tail = run.catch(() => {});
    return run;
  };
}

// File unique partagée par tous les appels XP du client.
const spacedQueue = createSpacedQueue();
let pendingXpCalls = 0;

export function enqueueXpCall(task) {
  pendingXpCalls += 1;
  return spacedQueue(task).finally(() => { pendingXpCalls -= 1; });
}

// Vrai tant qu'un appel XP attend son tour ou s'exécute : ne pas recharger la page à ce moment-là.
export const hasPendingXpCalls = () => pendingXpCalls > 0;
